import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useState } from 'react';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';
import TextArea from 'primitives/TextArea';

import ErrorMessage from 'components/ErrorMessage';

const OVERRIDE_JOINT_DEMAT_WARNING_MUTATION = gql(`
  mutation OverrideJointDematWarning($id: ID!, $note: String) {
    overrideJointDematWarning(id: $id, note: $note) {
      id
      jointDematCheckStatus
      jointDematDetected
    }
  }
`);

// Status-independent by design on the backend (ops may need to override this warning at any
// point) — so this action is always available, not gated on request status.
const OverrideJointDematWarningButton: FC<{ id: string }> = ({ id }) => {
  const [showDialog, toggleDialog] = useState(false);
  const [note, setNote] = useState('');
  const [overrideJointDematWarning, { loading, error }] = useMutation(
    OVERRIDE_JOINT_DEMAT_WARNING_MUTATION
  );

  return (
    <>
      <Button variant="secondary" onClick={() => toggleDialog(true)}>
        Override Joint Demat Warning
      </Button>
      <Dialog open={showDialog} onClose={() => toggleDialog(false)}>
        <DialogPanel>
          <DialogTitle>Override Joint Demat Warning</DialogTitle>
          <p className="mb-4">
            This overrides the automated joint-demat check for this request. Add a note explaining
            why.
          </p>
          <TextArea
            label="Note (optional)"
            value={note}
            onChange={e => setNote(e.target.value)}
            fullWidth
          />
          {error && <ErrorMessage error={error} type="alert" />}
          <DialogActions>
            <Button variant="secondary" onClick={() => toggleDialog(false)}>
              Cancel
            </Button>
            <Button
              loading={loading}
              onClick={() =>
                overrideJointDematWarning({ variables: { id, note: note || undefined } }).then(
                  () => {
                    toggleDialog(false);
                    setNote('');
                  }
                )
              }
            >
              Override
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default OverrideJointDematWarningButton;
